import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import { PostAdjusterOtherDamagedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAdjusterOtherDamagedImages/postAdjusterOtherDamagedImagesQuery.type';

export const postAdjusterOtherDamagedImagesFunction = (
  params: PostAdjusterOtherDamagedImagesQueryParamsType,
): Promise<{}> => {
  const data = new FormData();
  params.data.forEach((element, index) => {
    const image = ConvertUrlToFile(element.image, 'image', 'image');
    data.append(`damaged_images[${index}]image`, image);
  });
  return fetchApi({
    method: 'post',
    url: `property/reports/${params.id}/accident_users/damaged/adjuster/damaged/`,
    data,
    params: { damaged_id: params.damagedId },
  });
};
